import React, { useEffect, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { useNavigate, Navigate } from 'react-router-dom';
import {
  Container,
  Paper,
  Typography,
  Box,
  CircularProgress
} from '@mui/material';
import UserManagement from '../components/projects/UserManagement';
import { usePermissions } from '../hooks/usePermissions';
import { PERMISSIONS } from '../config/permissions';

export default function EmployeeManagement() {
  const { user, role, loading, roleLoading } = useContext(AuthContext);
  const { hasPermission } = usePermissions();

  if (loading || roleLoading) {
    return (
      <Container maxWidth="lg" sx={{ mt: '80px', mb: 4, pt: 2, minHeight: 'calc(100vh - 80px)' }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
          <CircularProgress />
          <Typography sx={{ ml: 2 }}>Laden van gebruikersgegevens...</Typography>
        </Box>
      </Container>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const canManage = hasPermission(PERMISSIONS.MANAGE_EMPLOYEES);
  if (!canManage) {
    return <Navigate to="/" replace />;
  }

  return (
    <Container maxWidth="lg" sx={{ 
      mt: '80px',
      mb: 4,
      pt: 2,
      minHeight: 'calc(100vh - 80px)',
    }}>
      <Paper elevation={3} sx={{ p: 3 }}>
        <Typography variant="h4" gutterBottom>
          Werknemersbeheer
        </Typography>
        
        <UserManagement />
      </Paper>
    </Container>
  );
}
